<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../../assets/home_banner1.png" alt="">
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="section_w content">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            IDC服务
          </p>
          <aside>
            IDC
          </aside>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-4 col-xs-12 index_content_card">
            <img src="../../assets/idc_pic01.png" alt="">
            <div>
                <p class="text_ellipsis">
                  资深服务团队
                </p>
                <div class="text">
                  超过20年大型系统集成经验的7*24专业团队;资深的服务管理团队,拥有10+项国际/国内认证
                  专业化精细分工,业务放心可托付,技术创新、自主研发，不断降低客户成本

                </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 index_content_card">
            <img src="../../assets/idc_pic02.png" alt="">
            <div>
                <p class="text_ellipsis">
                  定制化服务
                </p>
                <div class="text">
                  自主研发的云悦服务,通过标准化流程和管理,全方位根据客户要求定制优质服务,全程责任客服代表,7*24小时质询响应
                  7*24小时保安巡逻及监控机制和标准流程

                </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 index_content_card">
            <img src="../../assets/idc_pic03.png" alt="">
            <div>
                <p class="text_ellipsis">
                  丰富的软硬件设施
                </p>
                <div class="text">
                  大规模的网络空间基础设施运营平台,提供应急响应中心,提供双线、电信、网通骨干机房托管;赠送公网IP;全国各地机房均可免费测试3天;服务器采用当前主流配置,可定制;高性能防火墙防御DDOS;42U标准机柜,双路供电,15A电流
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w Program" style="padding-bottom: 0px">
      <div class="container" style="position: relative; z-index: 10">
        <div class="section_title right">
          <p>
            机房优势
          </p>
          <aside>
            engine  room
          </aside>
        </div>
      </div>
      <div class="program_content program_content_big">
        <div class="container">
          <div class="row">
            <div class="col-sm-3 program_card">
              <p>多种线路</p>
              <span>
              BGP、SDN、MSTP、DDN专线，网络更快，更稳定
            </span>
              <div class="text-center">
                <img src="../../assets/program_icon01.png" alt="">
              </div>
            </div>
            <div class="col-sm-3 program_card" style="padding-top: 170px">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon02.png" alt="">
              </div>
              <p>覆盖广泛</p>
              <span>
              北京、上海、广州、武汉等核心节点，分布在全国大多数重要城市的2、3级优势节点
            </span>
            </div>
            <div class="col-sm-3 program_card">
              <p>服务保障</p>
              <span>
              先进的标准化数据中心，整体一站式托管服务
            </span>
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon03.png" alt="">
              </div>
            </div>
            <div class="col-sm-3 program_card" style="padding-top: 100px">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon04.png" alt="">
              </div>
              <p>专业团队</p>
              <span>
              专业的运维团队、以百度自动化运维为核心的保障技术
            </span>
            </div>
          </div>
        </div>
      </div>
      <div class="program_content program_content_xs">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon01.png" alt="">
              </div>
              <p>多种线路</p>
              <span>
              BGP、SDN、MSTP、DDN专线，网络更快，更稳定
            </span>

            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon02.png" alt="">
              </div>
              <p>覆盖广泛</p>
              <span>
              北京、上海、广州、武汉等核心节点，分布在全国大多数重要城市的2、3级优势节点
            </span>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon03.png" alt="">
              </div>
              <p>服务保障</p>
              <span>
              先进的标准化数据中心，整体一站式托管服务
            </span>

            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/program_icon04.png" alt="">
              </div>
              <p>专业团队</p>
              <span>
              专业的运维团队、以百度自动化运维为核心的保障技术
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w introduction">
      <div class="container" style="position: relative;z-index: 33">
        <div class="section_title left">
          <p>
            机房展示
          </p>
          <aside>
            engine  room
          </aside>
        </div>
        <div class="row">
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic01.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic02.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic03.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic04.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic05.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic06.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic07.png" alt="">
          </div>
          <div class="col-sm-3 col-xs-6">
            <img src="../../assets/enging_room_pic08.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section_w source">
      <div class="container" >
        <div class="section_title right">
          <p>
            机房资源分布展示
          </p>
          <aside>
            engine  room
          </aside>
        </div>
        <div class="row" style="background-color: #fff;padding-top: 15px;padding-bottom: 15px">
          <div class="col-md-7">
            <img src="../../assets/resources_map.png" alt="">
          </div>
          <div class="col-md-5 address">
            <p>
              <b>华东：</b><span>上海市</span> <span>济南市</span>   <span>滨州市</span>   <span>枣庄市</span>   <span>泰州市</span>   <span>淮安市</span>   <span>合肥市</span>  <span>湖州市</span>   <span>台州市</span>   <span>丽水市</span>   <span>泉州市</span>   <span>厦门市</span>
            </p>
            <p>
              <b>华南：</b><span>广州市</span>   <span>佛山市</span>   <span>南宁市</span>   <span>海口移动</span>
            </p>
            <p>
              <b>华北：</b> <span>北京市</span>   <span>天津市</span>   <span>石家庄市</span>   <span>太原市</span>   <span>忻州市</span>   <span>内蒙古</span>
            </p>
            <p>
              <b>华中：</b> <span>鄂州市</span>   <span>武汉市</span>   <span>襄阳市</span>   <span>长沙市</span>   <span>郑州市</span>   <span>新乡市</span>   <span>商丘市</span>   <span>九江市</span>   <span>南昌市</span>
            </p>
            <p>
              <b>西南：</b> <span>重庆市</span>  <span>贵阳市</span>   <span>昆明市</span>   <span>拉萨移动</span>
            </p>
            <p>
              <b>东北：</b> <span>辽阳市</span>   <span>延边州</span>   <span>长春市</span>   <span>哈尔滨市</span>
            </p>
            <p>
              <b>西北：</b> <span>咸阳市</span>   <span>西安市</span>   <span>铜川市</span>   <span>兰州市</span>   <span>西宁电信</span>   <span>银川联通</span>   <span>克拉玛依移动</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="section_w" style="padding-bottom: 0px">
      <div class="container" >
        <div class="section_title left">
          <p>
            IDC数据中心客户
          </p>
          <aside>
            IDC  client
          </aside>
        </div>
      </div>
      <div class="Customer">
        <div class="container">
          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh01.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh02.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh03.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh04.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh05.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh06.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh07.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh08.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh09.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh10.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh11.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh12.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh13.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh14.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh15.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh16.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh17.png" alt="">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/idc_kh18.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--<div class="article">-->
      <!--<div class="container">-->
        <!--<div class="row parper" style="position: relative">-->
         <!--<div class="col-sm-6">-->
            <!--<img src="../../assets/article_pic.jpg" alt="">-->
          <!--</div>-->
          <!--<div class="col-sm-6 article_img">-->
            <!--<img src="../../assets/article_pic.jpg" style="height: 100%" alt="">-->
          <!--</div>-->
          <!--<div class="col-sm-6 text">-->
            <!--随着云计算，物联网和大数据的发展，互联网迎来第二次蓬勃发展。以阿里云为首的巨无霸公有云服务商通过价格战占据的中小企业客户的半壁江山。而传统的云服务商在价格上无法和阿里等抗衡。<br>-->
            <!--我们通过现有的为平安合作的资源整合起来为中小CDN公司，视频服务公司等提供服务。<br>-->
            <!--通过全国40多个分布式节点，10多个超过5个万兆以上的主力节点为分布式接入和计算提供数据服务。为企业客户通过混合运和定制私有云搭建和业务连续性运维服务。在北京，上海，天津，广州等骨干节点，通过备份机房和冗灾服务。<br>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="section_w" style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title right">
          <p>
            我们的优势
          </p>
          <aside>
            Advantage
          </aside>
        </div>
      </div>
      <div class="youshi">
        <div class="container">
          <div class="row youshi_big">
            <img src="../../assets/youshi.png" alt="">
            <div class="youshi_main">
              <div class="youshi1">
                <h4>丰富的资源储备</h4>
                <p>国内大多数重要城市带宽节点，国内大多数一至三线城市IDC机房。</p>
              </div>
              <div class="youshi2">
                <h4>广泛的服务网络</h4>
                <p>遍布全国的服务网络与备品备件库。</p>
              </div>
              <div class="youshi3">
                <h4>精确的运维能力</h4>
                <p>精确到毫秒的智能化监控运维能力。</p>
              </div >
              <div class="youshi4">
                <h4>丰富的客户资源</h4>
                <p>平安、白山云、蓝汛、帝联、逸云、云端智度等业内一线CDN厂商，为我们带来源源不断的海量需求。</p>
              </div>
              <div class="youshi5">
                <h4>去中心化的可信联盟</h4>
                <p>悦享互联AIOPS智能运维及预防性维护能力，像黑客帝国中的复制人特工Agent Smith一样快速复制能力，快速解决目标。</p>
              </div>
            </div>
          </div>
          <div class="row youshi_small">
            <div class="col-sm-4 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/Advantage_icon01.png" alt="">
              </div>
              <p>丰富的资源储备</p>
              <span  class="text-center">
              国内大多数重要城市带宽节点，国内大多数一至三线城市IDC机房。
            </span>
            </div>
            <div class="col-sm-4 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/Advantage_icon02.png" alt="">
              </div>
              <p>广泛的服务网络</p>
              <span class="text-center">
              遍布全国的服务网络与备品备件库。
            </span>
            </div>
            <div class="col-sm-4 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/Advantage_icon03.png" alt="">
              </div>
              <p>精确的运维能力</p>
              <span class="text-center">
              精确到毫秒的智能化监控运维能力。
            </span>
            </div>
            <div class="col-sm-4 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/Advantage_icon04.png" alt="">
              </div>
              <p>丰富的客户资源</p>
              <span class="text-center">
              平安、白山云、蓝汛、帝联、逸云、云端智度等业内一线CDN厂商，为我们带来源源不断的海量需求。
            </span>
            </div>
            <div class="col-sm-4 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../../assets/Advantage_icon05.png" alt="">
              </div>
              <p>去中心化的可信联盟</p>
              <span class="text-center">
              悦享互联AIOPS智能运维及预防性维护能力，像黑客帝国中的复制人特工Agent Smith一样快速复制能力，快速解决目标。
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w yunwei">
      <div class="container">
        <p>
          数据中心海量设备对于运维的要求日益提升，传统运维技术已经远远无法满足要求，自动化运维已经从传统运维过渡到DevOPS，并向AIOPS（人工智能运维）进化，具备预防性维护的能力。悦享互联为客户提供精确到毫秒的智能化运维监控能力。
        </p>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic01.jpg" alt="">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic02.jpg" alt="">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic03.jpg" alt="">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic04.jpg" alt="">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic05.jpg" alt="">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <img src="../../assets/idc_datacenter_pic06.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import Footer from '../../components/Footer'
  export default {
    name: 'Dashboard',
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-container {
    width: 100%;
  }

  img {
    width: 100%;
  }

  .address {
    font-size: 18px;
  }
  .swiper-slide {
    text-align: center;
    font-size: 1.8rem;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .index_content_card {
    margin-bottom: 30px;
  }

  .index_content_card p {
    color: #ff9900;
    font-size: 2.4rem;
    margin-bottom: 5px;
  }

  .index_content_card > div {
    padding: 15px;
    border-bottom: 3px solid #fe9901;
    background-color: #fff;
  }

  .index_content_card span {
    margin-top: 8px;
    color: #2c3e50;
    display: block;
  }

  .index_content_card .text {
    color: #2c3e50;
    font-size:18px;
    line-height:32px;
    text-align:justify;
  }

  .index_content_card .text {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .content {
    background: url("../../assets/content_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
  }
  .Program {
    position: relative;
  }

  .index_content_card:hover > div {
    background-color: #fe9901;
  }

  .index_content_card:hover p {
    color: #fff
  }

  .index_content_card:hover span {
    color: #fff
  }

  .index_content_card:hover .text {
    color: #fff
  }

  .program_content {
    background: url("../../assets/program_bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    padding: 40px 0px 0px;
  }

  .program_card p {
    text-align: center;
    color: #8c4c00;
    font-size: 2.8rem;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .program_card span {
    color: #8c4c00;
    font-size: 2rem;
    margin-bottom: 20px;
    display: block;
  }

  .program_card img {
    width: 100px;
  }

  .program_content_xs {
    display: none;
  }

  .program_card {
    margin-bottom: 30px;
  }
  .introduction {
    background: url("../../assets/enging_room_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .source {
    background: url("../../assets/enging_room_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .introduction .row > div {
    margin-bottom: 30px;
  }

  .source p {
    margin-bottom: 10px;
  }
  .source p span{
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 8px;
  }
  .Customer {
    background: url("../../assets/client_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .Customer .row >div {
    margin-bottom: 30px;
  }
  .article {
    padding: 100px 0px 40px;
    background: url("../../assets/article_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .article .row>div {
    line-height: 28px;
    font-size: 1.8rem;
    color: #333;
  }
  .article .text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .parper {
    box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);
  }

  .article_img {
    display: none;
  }
  .youshi {
    background-color: #faedc1;
  }
  .youshi >div {
    padding-top: 50px;
    padding-bottom: 10px;
  }
  .youshi_big {
    position: relative;
    width: 100%;
    padding: 23.79% 0;
    display: none;
  }
  .youshi_big img {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: auto;
  }
  .youshi_big .youshi_main {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
  }
  .youshi_main h4 {
    font-weight: bold;
    color: #b2670e;
    font-size: 2.8rem;
  }
  .youshi_main p {
    font-weight: normal;
    color: #b2670e;
    font-size: 2rem;
  }
  .youshi1 {
    width: 18%;
    position: absolute;
    left: 1%;
    top: 25%;
  }
  .youshi2 {
    width: 20%;
    position: absolute;
    left: 28%;
    top: 7%;
  }
  .youshi3 {
    width: 23%;
    position: absolute;
    left: 16%;
    top: 63%;
  }
  .youshi4 {
    width: 29%;
    position: absolute;
    right: 27%;
    top: 63%;
  }
  .youshi5 {
    width: 25%;
    position: absolute;
    right: -15px;
    top: 28%;
  }
  .yunwei p {
    line-height: 35px;
    margin-bottom: 20px;
    font-size: 2rem;
    color: #333;
  }
  .yunwei .row>div {
    margin-bottom: 30px;
  }
  @media (max-width: 991px) {
    .program_content_big {
      display: none;
    }

    .program_content_xs {
      display: block;
    }
    .youshi_small {
      display: block;
    }

  }

  @media (max-width: 768px) {
    .article .row>div {
      margin-bottom: 30px;
    }

    .content:after {
      display: none;
    }
    .Program:after {
      display: none;
    }

  }
  @media (min-width: 769px) {
    .article_img {
      width: 50%;
      height: 100%;
      position: absolute;
      left: 0px;
      top: 0px;
      padding: 0px;
      display: block;

    }
    .index_content_card > div {
      min-height: 365px;
    }

  }
  @media (min-width: 992px) {
    .youshi_big {
      display: block;
    }
    .youshi_small {
      display: none;
    }
    .address {
      padding-top: 30px;
    }
    .index_content_card > div {
      min-height: 280px;
    }
  }
</style>
